var audio = new Audio('sounds/bell.mp3')

const coreData = {
  filters: {
    dayFilter: function (value) {
        if (!value) return ''
        var days = {
          monday : 'Montag',
          tuesday : 'Dienstag',
          wednesday : 'Mittwoch',
          thursday : 'Donnerstag',
          friday : 'Freitag',
          saturday : 'Samstag',
          sunday : 'Sonntag',
        }
        value = days[value]
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  data(){
    return {
      chatPartner: null,
      heartbeat: null,
    }
  },
  computed: {
    URL(){
      return process.env.VUE_APP_API_BASEURL
    },
    extras(){
      return this.$store.getters.extras
    },
    categories(){
      return this.$store.getters.categories
    },
    connection(){
      return this.$store.getters.connection
    },
    updating(){
      return this.$store.getters.updating
    },
    orders(){
      return this.$store.getters.orders
    },
    authError(){
      return this.$store.getters.authError
    },
    authMessage(){
      return this.$store.getters.authMessage
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },

    userInformations(){
      return this.$store.getters.userInformations
    },

    showUi(){
      return this.$store.getters.showUi
    },

    fullscreen(){
      return this.$store.getters.fullscreen
    },

    company(){
      return this.$store.getters.company
    },

    darkMode(){
      return this.$store.getters.darkMode
    },
  
    loadingData(){
      return this.$store.getters.loadingData
    },
    menus(){
      return this.$store.getters.menus
    },
    allergens(){
      return this.$store.getters.allergens
    },
    variants(){
      return this.$store.getters.variants
    },

    slots(){
      return this.$store.getters.slots
    },

    tables(){
      return this.$store.getters.tables
    },

    inHouseOrders(){
      return this.$store.getters.inHouseOrders
    },

    menuState(){
      return this.$store.getters.menuState
    },

    allergensOptions(){
      var array = []
        if(this.allergens){
          this.allergens.forEach(element => {
            array.push({value: element._id, text: element.title + ' ' + element.description})
          });
        }
        return array
    },
    additives(){
      return this.$store.getters.additives
    },

    media(){
      return this.$store.getters.media.filter(el => el !== '.DS_Store')
    },

    additivesOptions(){
      var array = []
        if(this.additives){
          this.additives.forEach(element => {
            array.push({value: element._id, text: element.title + ' - ' + element.description})
          });
        }
        return array
    },

    extrasOptions(){
      var array = []
        if(this.extras){
          this.extras.forEach(element => {
            var price = ''
              try {
                if(element.price){
                  price = ' (+ ' + parseFloat(element.price).toFixed(2)  + '€)'
                }
              } catch (error) {
                console.log(error)
              }
            array.push({value: element._id, text: element.title + price, data: element})
          });
        }
        return array
    },

    extrasTemplates(){
      return this.$store.getters.extrasTemplates
    },

    extrasTemplatesOptions(){
      var array = []
        if(this.extrasTemplates){
          this.extrasTemplates.forEach(element => {
            array.push({value: element, text: element.title + ' - ' + element.description})
          });
        }
        return array
    },

    variantsTemplates(){
      return this.$store.getters.variantsTemplates
    },

    variantsTemplatesOptions(){
      var array = []
        if(this.variantsTemplates){
          this.variantsTemplates.forEach(element => {
            array.push({value: element, text: element.title + ' - ' + element.description})
          });
        }
        return array
    },

    categoriesOptions(){
      var array = [{value: {}, text: 'keine Auswahl'}]
        if(this.categories){
          this.categories.forEach(element => {
            array.push({value: element, text: element.title})
          });
        }
        return array
    },

    variantsOptions(){
      var array = [{value: {}, text: 'keine Auswahl', data: {}}]
        if(this.additives){
          this.variants.forEach(element => {
            var price = ''
            try {
              if(element.price){
                price = ' (+ ' + parseFloat(element.price).toFixed(2)  + '€)'
              }
            } catch (error) {
              console.log(error)
            }
            
            array.push({value: element._id, text: element.title + price, data: element})
          });
        }
        return array
    },

  },
  
  mounted() {

    // if(this.loggedIn){
    //   this.$store.dispatch('getAllergens');
    //   this.$store.dispatch('getAdditives');
    //   this.$store.dispatch('getMenus');
    //   this.$store.dispatch('getCompany');
    //   this.$store.dispatch('userInformations');
    //   this.$store.dispatch('getOrders');
    //   this.$store.dispatch('getExtras');
    //   this.$store.dispatch('getCategories');
    // }

  },
  watch:{
    loggedIn(){
      if(this.loggedIn){
        this.$store.dispatch('getAllergens');
        this.$store.dispatch('getInHouseOrders');
        this.$store.dispatch('getTables');
        this.$store.dispatch('getAdditives');
        this.$store.dispatch('getMenus');
        this.$store.dispatch('getCompany');
        this.$store.dispatch('userInformations');
        this.$store.dispatch('getOrders');
        this.$store.dispatch('getExtras');
        this.$store.dispatch('getVariants');
        this.$store.dispatch('getCategories');   
        this.$store.dispatch('getExtrasTemplates');
        this.$store.dispatch('getVariantsTemplates');
      }
    },
    
  },
  created(){
    this.$moment.locale('de')
    if(this.loggedIn){
      // this.$store.dispatch('userInformations')
      // this.$store.dispatch('getAllergens')
      // this.$store.dispatch('getCompany')
    }else{
      if(this.$route.name != 'Registrieren' && this.$route.name != 'Resetpassword' && this.$route.name != 'Datenschutz'  
      && this.$route.name != 'Impressum'){
        this.$store.dispatch('tryAutoLogin')
      }
    }
  },
  beforeDestroy(){
    clearInterval(this.heartbeat)
  },
  methods: {
    refreshData(){
      if(this.loggedIn){
        this.$store.dispatch('getAllergens');
        this.$store.dispatch('getInHouseOrders');
        this.$store.dispatch('getTables');
        this.$store.dispatch('getAdditives');
        this.$store.dispatch('getMenus');
        this.$store.dispatch('getCompany');
        this.$store.dispatch('userInformations');
        this.$store.dispatch('getOrders');
        this.$store.dispatch('getExtras');
        this.$store.dispatch('getVariants');
        this.$store.dispatch('getCategories');
        this.$store.dispatch('getMedia');
        this.$store.dispatch('getExtrasTemplates');
        this.$store.dispatch('getVariantsTemplates');
      }
    },

    playSound(){
      audio.play()
    },

    showOrder(record){
      this.$router.push('/bestellung/' + record._id).catch(() => {})
    },
    getBadgeVariant(status){
      if(status == 'storniert') return 'danger'
      if(status == 'abgeschlossen') return 'primary'
      if(status == 'bestellt') return 'warning'
      if(status == 'bestätigt') return 'success'
      if(status == 'bereit') return 'info'
      if(status == 'abgeholt') return 'primary'

      return ''
    },

    getTotalPrice2(menu){
      var price = 0
      if(menu.items){
        menu.items.forEach(el => {    
          price += el._id.price * el.amount
          if(el.extras){
            el.extras.forEach(extra => {
              if(extra.choosen){
                price += extra.price
              }
              
            })
          }
        })
      }
      return price.toFixed(2) +'€'
    },


    getTotalPrice(menu){
      var total = 0.00
      if(menu.delivery_fee){
        if(menu.delivery_fee > 0){
          total += parseInt(menu.delivery_fee)
        }
      }
      if(!menu) return total.toFixed(2)
      if(menu.items.length == 0) return total.toFixed(2)

      menu.items.forEach(item => {
        total += item._id.price * item.amount
        if(item.extras){
          item.extras.forEach(extra => {
            if(extra.choosen){
              total += extra.price * item.amount
              if(item.variants.length > 0){
                item.variants.forEach(variant => {
                  if(variant.choosen){
                    total += variant.choosen.extra_price * item.amount
                  }
                })
              }
            }
          })
          if(item.variants.find(variant => variant.choosen)){
            item.variants.filter(variant => variant.choosen).forEach(element => {
              total += element.choosen.price * item.amount
            })
          }
        }
      })

      return total.toFixed(2)
    },

    // getTotalPrice2(menu){
    //   var price = 0
    //   if(menu.items){
    //     menu.items.forEach(el => {    
    //       price += el._id.price * el.amount
    //       if(el.extras){
    //         el.extras.forEach(extra => {
    //           if(extra.choosen){
    //             price += extra.price
    //           }
              
    //         })
    //       }
    //     })
    //   }
    //   return price.toFixed(2) +'€'
    // },


    checkOpeningTimes(){
      var done = false
      var vm = this

      Object.keys(vm.company.opening_times).forEach(function(key) {
        if(vm.company.opening_times[key].start_1 || vm.company.opening_times[key].start_2 || vm.company.opening_times[key].end_1 || vm.company.opening_times[key].end_2){
          done = true
          return true
        }
      });

      return done
    },
    checkDeliveryTimes(){
      var done = false
      var vm = this

      if(!this.company.delivery) return true
      Object.keys(vm.company.delivery_times).forEach(function(key) {
        if(vm.company.delivery_times[key].start_1 || vm.company.delivery_times[key].start_2 || vm.company.delivery_times[key].end_1 || vm.company.delivery_times[key].end_2){
          done = true
          return true
        }
      });

      return done
    },
    updateCompanyDelayed(){
      var delayInMilliseconds = 200; //1 second
      var vm = this;
      setTimeout(function() {
        vm.updateCompany()
      }, delayInMilliseconds);
    },
    updateCompany(){
      console.log('updateCompany')
      var testString = this.company.contact.phone.substring(0,3)
      var mobileNumber = '+49' + parseInt(this.company.contact.phone, 10)
      if(testString === '+49'){
        mobileNumber = this.company.contact.phone
      }

      this.company.contact.phone = mobileNumber

      var payload = {
        _id: this.company._id,
        data: {
          opening_times: this.company.opening_times,
          delivery_times: this.company.delivery_times,
          payment_methods: this.company.payment_methods,
          delivery: this.company.delivery,
          enable_online_order: this.company.enable_online_order,
          url: this.company.url,
          available_days: this.company.available_days,
          active: this.company.active,
          contact: this.company.contact,
          amount_slots: this.company.amount_slots,
          pre_time: this.company.pre_time,
          actual_delivery_time: this.company.actual_delivery_time,
          minimum_order_value: this.company.minimum_order_value,
          maximum_delivery_radius: this.company.maximum_delivery_radius
        }
      }
      this.$store.dispatch('updateCompany', payload)
    },
    getImage(link){
      return process.env.VUE_APP_API_BASEURL + '/' + link
    },
    getChatName(_id){
      var user = this.company.users.find(el => el._id == _id)
      if(user){ 
        return user.firstname + ' ' + user.lastname
      }
      return ''
    },
    keepalive(){
      if(this.connection){
        this.connection.send(JSON.stringify({heartbeat: true}))
      }else{
        this.connection = new WebSocket(process.env.VUE_APP_WEBSOCKET_BASEURL)
      }
       
    },
    getChatpartner(_id){
      this.$store.dispatch('getChats',{ _id: _id})
    },
    
    createURL(data){
      const objectURL = URL.createObjectURL(data)
      return objectURL
    },

    sendNotification(title, message, devices){
      var array = []
      devices.forEach(element => {
        if(element.deviceTokens){
          if(element.deviceTokens.length > 0){
            element.deviceTokens.forEach(deviceToken => {
              array.push(deviceToken.token)
            })
          }
        }
      })
      const payload = {
        title: title,
        message: message,
        devices: array,
        users: devices
      }
      this.$store.dispatch('postNotification', payload)

    },
    
    // makeToast(append, title, content, variant) {
    //   this.$bvToast.toast(content, {
    //     title: title,
    //     autoHideDelay: 5000,
    //     appendToast: append,
    //     variant: variant
    //     }
    //   )
    //   this.$store.dispatch('resetToasts')
    // },
    
    // scrollToTop(){
    //   window.scrollTo({top: 0, behavior: 'smooth'});
    // },
    windowOpen(link){
      window.open(link, "_blank")
    },
  }
}

export default coreData